/* Product card image carousel — lightweight scroll-snap slider with arrows + dots.
   Registered as a custom element so cards added later (infinite scroll, quick view,
   recommendations) initialise automatically via connectedCallback. */
(function () {
  if (window.customElements && customElements.get('product-card-carousel')) return;

  class ProductCardCarousel extends HTMLElement {
    connectedCallback() {
      if (this._initialised) return;
      this._initialised = true;

      this.track = this.querySelector('[data-pcc-track]');
      this.slides = this.track ? Array.from(this.track.children) : [];
      this.dots = Array.from(this.querySelectorAll('.product-item__carousel-dot'));
      this.prevBtn = this.querySelector('[data-pcc-prev]');
      this.nextBtn = this.querySelector('[data-pcc-next]');

      if (!this.track || this.slides.length < 2) {
        if (this.prevBtn) this.prevBtn.hidden = true;
        if (this.nextBtn) this.nextBtn.hidden = true;
        return;
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.step(-1); });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.step(1); });
      }

      let raf = null;
      this.track.addEventListener('scroll', () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.sync());
      }, { passive: true });

      this.sync();
    }

    currentIndex() {
      const w = this.track.clientWidth || 1;
      return Math.round(this.track.scrollLeft / w);
    }

    scrollToIndex(i) {
      const clamped = Math.max(0, Math.min(this.slides.length - 1, i));
      this.track.scrollTo({ left: this.track.clientWidth * clamped, behavior: 'smooth' });
    }

    step(direction) {
      this.scrollToIndex(this.currentIndex() + direction);
    }

    sync() {
      const i = this.currentIndex();
      this.dots.forEach((dot, idx) => dot.classList.toggle('is-active', idx === i));
      if (this.prevBtn) this.prevBtn.hidden = i <= 0;
      if (this.nextBtn) this.nextBtn.hidden = i >= this.slides.length - 1;
    }
  }

  customElements.define('product-card-carousel', ProductCardCarousel);
})();